import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import ProductOfBrand from './ProductOfBrand';

const SiteFooter = () => (
  <Box
    component="footer"
    sx={{
      color: 'text.secondary',
      py: 2,
      flexShrink: 0,
      backgroundColor: 'background.paper',
    }}
  >
    <Container maxWidth="lg">
      <Box sx={{ textAlign: 'center' }}>
        <ProductOfBrand sx={{ opacity: 0.7, mb: 0.5 }} />
        <Typography variant="body2" sx={{ opacity: 0.7 }}>
          © 2026 ESG Dynamics. All rights reserved.
        </Typography>
      </Box>
    </Container>
  </Box>
);

export default SiteFooter;
